import { observer } from "mobx-react-lite"

import type { VenammSellStore } from "@/domains/venamm"
import { ExternalTxLink } from "@/domains/common/components/external-tx-link"
import { MessageBoxIcon } from "@/domains/common/components/message-box-icon"
import { MultilineMessageBox } from "@/domains/common/components/multi-line-message-box"
import { ShortMessageBox } from "@/domains/common/components/short-message-box"
import { BodySM } from "@/domains/design/components/body-sm"
import { formatCurrency } from "@/domains/library"

interface VenammCheckingApprovalProps {
  store: VenammSellStore
  governanceTokenSymbol?: string
}

export const VenammCheckingApproval = observer(
  ({ store, governanceTokenSymbol = "SCALE" }: VenammCheckingApprovalProps) => {
    if (store.quote) {
      const Component = store.resetTxHash ? MultilineMessageBox : ShortMessageBox
      return (
        <Component variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
          <BodySM className="text-t200">
            You will receive {formatCurrency(store.quote.value)} {governanceTokenSymbol} for NFT #{store.lock?.id}
            {store.quote.haircut > 0 && ` (${store.quote.haircut.toFixed(2)}% haircut)`}
          </BodySM>
          {store.resetTxHash && <ExternalTxLink url={store.resetTxHashUrl} title="View reset tx" className="mt-2" />}
        </Component>
      )
    }

    return (
      <ShortMessageBox variant="info" icon={<MessageBoxIcon size={"md"} variant="info" />}>
        <BodySM className="text-t200">Checking approval status...</BodySM>
      </ShortMessageBox>
    )
  },
)

